import { EntityModel } from '@/interfaces'
import {
  ALL_TEAMS_QUERY,
  CREATE_TEAM_MUTATION,
  DELETE_TEAM_MUTATION,
  FORCE_DELETE_TEAM_MUTATION,
  SINGLE_TEAM_QUERY,
  UPDATE_TEAM_MUTATION,
} from './graphql'
import travelGuideEntity from '@/entities/travelGuide/entity'

const travelTeamModel: EntityModel = {
  name: 'team',
  namePlural: 'teams',
  uniqueName: 'travelTeam',
  uniqueNamePlural: 'travelTeams',
  path: 'travel/team',
  baseUrl: '/travel/teams',
  translationPrefix: 'entities:travelTeam.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_TEAMS_QUERY,
    getSingle: SINGLE_TEAM_QUERY,
    create: CREATE_TEAM_MUTATION,
    update: UPDATE_TEAM_MUTATION,
    delete: DELETE_TEAM_MUTATION,
    forceDelete: FORCE_DELETE_TEAM_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:travelTeam.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    members: {
      name: 'members',
      label: 'entities:travelTeam.attributes.members.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelGuideEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelTeamModel
